import { render, staticRenderFns } from "./rm-variant-input.vue?vue&type=template&id=6238d59f&"
import script from "./rm-variant-input.vue?vue&type=script&lang=js&"
export * from "./rm-variant-input.vue?vue&type=script&lang=js&"
import style0 from "./rm-variant-input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports